import type { DifficultyTier } from "./types.ts";

export function difficultyFor(round: number): DifficultyTier {
  if (round <= 12) return { delayMin: 500, delayMax: 3000, windowMs: 5000 };
  if (round <= 25) return { delayMin: 500, delayMax: 6000, windowMs: 3000 };
  if (round <= 38) return { delayMin: 0, delayMax: 10000, windowMs: 1500 };
  if (round <= 50) return { delayMin: 0, delayMax: 15000, windowMs: 600 };
  return { delayMin: 0, delayMax: 15000, windowMs: 400 };
}
